import React from 'react'
import { useEffect } from 'react'
import { FaEdit } from 'react-icons/fa'
import { AiFillDelete } from 'react-icons/ai'
import { useDispatch, useSelector } from 'react-redux'
import { getCarsBrandFilter } from '../actions'
import AddCar from '../components/CarDetail/CarModel/AddCar'
import DeleteModal from './DeleteModal'
import { useState } from 'react'

const Modal = ({ ID }) => {
    const dispatch = useDispatch()
    const [deleteID, setDeleteID] = useState('')
    const [deleteData, setDeleteData] = useState({})

    useEffect(() => {
        dispatch(getCarsBrandFilter(ID))
    },[ID, ,])

    const cars = useSelector(state => state.home.carsWithBrandFilter)?.response

    console.log("cars", cars, ID);

    const showDelete = (delData) => {
        setDeleteData(delData)
        console.log("delData", delData);
    }
    const showEdit = (delData) => {
        setDeleteData(delData)
        console.log("delData", delData);
    }

  return (    
    <div className="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <AddCar ID={ID} editData={deleteData}/>
        <DeleteModal ID={deleteData?.carModelId}/>
        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
                <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLongTitle">Car Detail</h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                </div>
                <div className="modal-body" style={{width:"600px"}}>
                <table className="table">
                    <thead>
                        <tr>
                        <th scope="col">No</th>
                        <th scope="col">Name</th>
                        <th scope="col">Name Ar</th>
                        <th scope="col">Priority</th>
                        <th scope="col">Status</th>
                        <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {( cars?.length > 0) ? cars?.map((car, indx) => 
                            <tr key={indx}>
                                <th scope="row">{indx+1}</th>
                                <td>{car?.name}</td>
                                <td>{car?.nameAr}</td>
                                <td>{car?.priority}</td>
                                <td>{car?.status === true ? 'Active' : 'In-Active'}</td>
                                <td>
                                    <FaEdit className='form_icon' onClick={() => showEdit(car)} data-toggle="modal" data-target="#addCarModel"/>
                                    <AiFillDelete className='form_icon' data-toggle="modal" onClick={() => showDelete(car)} data-target="#deleteCarModal"/>
                                </td>
                            </tr>
                        ) : <tr>Nothing to Show Here</tr>}
                    </tbody>
                </table>
                </div>
                <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
                <button type="button" className="btn btn-info" data-toggle="modal" data-target="#addCarModel">Add Car</button>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Modal